import React from "react";
import "./Spinner.css";

export default function Spinner() {
  const bars = Array.from({ length: 12 });

  return (
    <div className="spinner">
      {bars.map((_, i) => (
        <div key={i} className={`bar bar-${i + 1}`} />
      ))}
    </div>
  );
}
